import CheckoutPageConfiguration from './CheckoutPageConfiguration';

export default CheckoutPageConfiguration;
